import React, { ReactElement } from 'react';
import clsx from 'clsx';

interface TabProps {
  icon?: ReactElement;
  label: string;
  active: boolean;
  onClick?: () => void;
  dataTestId?: string;
}

const Tab: React.FC<TabProps> = ({ icon, label, active, onClick, dataTestId }) => {
  return (
    <div
      onClick={onClick}
      data-testid={dataTestId}
      className={clsx(
        'flex py-4 cursor-pointer uppercase font-semibold relative',
        active &&
          'border-b-2 border-content-brand text-content-brand [&:after]:content-[""] [&:after]:h-[3px] [&:after]:w-full [&:after]:bg-content-brand [&:after]:absolute [&:after]:bottom-0',
        active ? 'bg-white' : 'bg-[var(--ringil3-quaternary-color)]',
      )}
    >
      <div className="flex px-6 gap-4 whitespace-nowrap justify-center items-center">
        {icon && <span className={active ? 'text-content-brand' : 'text-content-secondary'}>{icon}</span>}
        <div className={clsx('flex text-sm tracking-wider max-sm:hidden', active ? 'text-content-brand' : 'text-content-gr4')}>{label}</div>
      </div>
    </div>
  );
};

export default Tab;
